import { css } from 'styled-components'

export const hideScrollbar = css`
  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
`

export const hideTextWithDots = css`
  width: ${({ width }) => width || '100%'};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
